import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { DistrictSettingsUpdateRequest } from "./DistrictSettingsUpdateRequest";
import { FacilitySettingsUpdateRequest } from "./FacilitySettingsUpdateRequest";
import { ScanStationSettingsUpdateRequest } from "./ScanStationSettingsUpdateRequest";

@Injectable()
export class DataService_MultiStationSettings {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	DistrictSettingsSelect() {
		var postResult$ = new Subject();
		var url = "MultiStation/DistrictSettingsSelect?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	DistrictSettingsUpdate(parms: DistrictSettingsUpdateRequest) {
		var postResult$ = new Subject();
		var url = "MultiStation/DistrictSettingsUpdate";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	FacilitySelectList(ApplicationItemID, SchoolID) {
		var postResult$ = new Subject();
		var url = "Report/FacilitySelectList?ApplicationItemID=" + ApplicationItemID + "&SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}

	MSFacilitySelectList(SchoolID) {
		var postResult$ = new Subject();
		var url = "MultiStation/MSFacilitySelectList?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}

	FacilitySelectListByUser() {
		var postResult$ = new Subject();
		var url = "Report/FacilitySelectListByUser?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}

	FacilitySettingsSelect(FacilityID) {
		var postResult$ = new Subject();
		var url = "MultiStation/FacilitySettingsSelect?FacilityID=" + FacilityID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	FacilitySettingsUpdate(parms: FacilitySettingsUpdateRequest) {
		var postResult$ = new Subject();
		var url = "MultiStation/FacilitySettingsUpdate";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	FacilitySettingsReset(FacilityID) {
		var postResult$ = new Subject();
		var url = "MultiStation/FacilitySettingsReset?FacilityID=" + FacilityID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	StationSettingsTableSelectList(FacilityID) {
		var postResult$ = new Subject();
		var url = "MultiStation/StationSettingsTableSelectList?FacilityID=" + FacilityID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	FacilityLocationSelectList(FacilityID) {
		var postResult$ = new Subject();
		var url = "MultiStation/FacilityLocationSelectList?FacilityID=" + FacilityID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	ScanStationSettingsUpdate(parms: ScanStationSettingsUpdateRequest) {
		var postResult$ = new Subject();
		var url = "MultiStation/ScanStationSettingsUpdate";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	PortalPanicAlertTopicSelectList(FacilityID) {
		var postResult$ = new Subject();
		var url = "MultiStation/PortalPanicAlertTopicSelectList?FacilityID=" + FacilityID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	SettingsFacilityLocationSelectList(FacilityID) {
		var postResult$ = new Subject();
		var url = "MultiStation/SettingsFacilityLocationSelectList?FacilityID=" + FacilityID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	IDCardTemplateSelectList(FacilityID) {
		var postResult$ = new Subject();
		var url = "MultiStation/IDCardTemplateSelectList?FacilityID=" + FacilityID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	SettingsVisiteeSelectList(FacilityID) {
		var postResult$ = new Subject();
		var url = "MultiStation/SettingsVisiteeSelectList?FacilityID=" + FacilityID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	SettingsPanicButtonTopicSelectList(FacilityID) {
		var postResult$ = new Subject();
		var url = "MultiStation/SettingsPanicButtonTopicSelectList?FacilityID=" + FacilityID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	SettingsFacilitySelectList() {
		var postResult$ = new Subject();
		var url = "MultiStation/SettingsFacilitySelectList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}
}
